import React from 'react'
import { Modal } from '../../../components/_EOS/Modal'
import { ModalReturnType } from '../../../hooks/useModal'
import { Asn } from '../../../interfaces/Asn/Asn'
import { ConfirmAction } from '../../../components/ConfirmAction'

interface ASNReceiveModalProps {
  receivedModalState: ModalReturnType<Asn>
  onReceive: (asn: Asn, comment?: string, isReserve?: boolean) => void
  isLoading?: boolean
}

export const ASNReceiveModal: React.FC<ASNReceiveModalProps> = ({
  receivedModalState,
  onReceive,
  isLoading = false
}) => {
  const handleReceiveConfirm = () => {
    // Usamos el asnId para verificar que coincida con el ASN actual
    if (receivedModalState.extendedProps) {
      onReceive(receivedModalState.extendedProps)
    }
  }

  const getConfirmTitle = () => {
    const asnNumber = receivedModalState.extendedProps?.asnNumber
    let additionalText = ''

    if (receivedModalState.extendedProps?.isPreSaleReception) {
      additionalText = `Producto VENTA EN VERDE solo disponible para pedidos reservados - `
    }

    return `${additionalText}¿Esta seguro que desea recepcionar el ASN N° ${asnNumber}?`
  }

  return (
    <Modal
      open={receivedModalState.isOpen}
      maxWidth={receivedModalState.size}
      title={receivedModalState.title}
      onClose={receivedModalState.closeModal}
      disableEscapeKeyDown={isLoading}
    >
      {receivedModalState.extendedProps && (
        <ConfirmAction
                  handleCloseModal={receivedModalState.closeModal}
                  handleSubmitAction={handleReceiveConfirm}
                  confirmTitle={getConfirmTitle()}
                  confirmText='Confirmar'
                  negateText='Cancelar'
                  isLoading={isLoading}
                />
      )}
    </Modal>
  )
}

